export const performanceHome = {
  title: 'Detalle SEO · {{name}}',
  subtitle: 'Impacto en posicionamiento, contenido y tráfico para el período seleccionado.',
  partialFilterBanner:
    'Filtros live aplicados parcialmente: Clicks, Impresiones, CTR y Branded vs Non-branded reflejan los filtros seleccionados. La Evolución, Top keywords y Países muestran totales del sitio (snapshot).',
  filters: {
    comparison: {
      label: 'Comparar vs',
      previousPeriod: 'Período anterior',
      previousYear: 'Año anterior',
      custom: 'Custom',
      goal: 'Objetivo',
      none: 'Sin comparación',
    },
    scope: {
      label: 'Alcance',
      all: 'Todas las páginas',
      blog: 'Solo blog',
    },
    scopes: {
      label: 'Alcance',
      placeholder: 'Elegí alcance',
      summary: '{{count}} seleccionados',
      summaryAll: 'Todo',
      'all': 'Todas las páginas',
      'platform-blog': 'Blogs de la plataforma',
      'legacy-blog': 'Blog legacy',
    },
    brand: {
      label: 'Marca',
      all: 'Marca + No-marca',
      branded: 'Solo marca',
      'non-branded': 'Solo no-marca',
    },
    country: {
      label: 'País',
      all: 'Todos los países',
      searchPlaceholder: 'Buscar país…',
      empty: 'Sin resultados',
      clear: 'Quitar filtro de país',
      multiSelected: '{{count}} países',
    },
    device: {
      label: 'Dispositivo',
      all: 'Todos',
      mobile: 'Mobile',
      desktop: 'Desktop',
      tablet: 'Tablet',
    },
  },
  textFilter: {
    trigger: 'Filtros avanzados',
    heading: 'Filtros avanzados',
    dimension: {
      query: 'Query',
      url: 'URL',
    },
    activeChipsLabel: 'Filtros activos',
    oneOf: {
      placeholder: 'Un valor por línea — pegá tu listado de URLs acá',
      count: '{{count}} valores',
      chipValue: '{{count}} valores',
      limitExceeded: 'Demasiados valores: máximo {{maxValues}} entradas / {{maxChars}} caracteres',
    },
  },
  segments: {
    trigger: 'Mis paneles',
    heading: 'Paneles guardados',
    savedHeading: 'Tus paneles',
    saveAs: 'Guardar vista actual…',
    updateActive: "Actualizar '{{name}}'",
    dirtyHint: 'Modificado — los filtros actuales difieren del panel guardado',
    share: 'Compartir con la organización',
    sharedBadge: 'Compartido',
    remove: 'Eliminar panel',
    saveDialog: {
      title: 'Guardar panel',
      description: 'Captura los filtros actuales como un panel reusable.',
      placeholder: 'Nombre del panel',
      submit: 'Guardar',
    },
    errors: {
      create: 'No se pudo guardar el panel. Intentá de nuevo.',
      update: 'No se pudo actualizar el panel. Intentá de nuevo.',
      remove: 'No se pudo eliminar el panel. Intentá de nuevo.',
      share: 'No se pudo compartir el panel. Intentá de nuevo.',
    },
    invalidRegexDropped:
      'Se descartaron condiciones con regex inválida del segmento.',
  },
  goals: {
    trigger: 'Objetivos',
    title: 'Objetivos del dashboard',
    description: 'Configurá objetivos site-wide para {{from}} a {{to}}.',
    loading: 'Cargando objetivos actuales...',
    empty: 'Todavía no hay objetivos configurados para este período.',
    retry: 'Reintentar',
    save: 'Guardar objetivos',
    saved: 'Objetivos guardados.',
    deleted: 'Objetivo eliminado.',
    cancel: 'Cancelar',
    placeholder: 'Entero positivo',
    currentValue: 'Objetivo aplicado actual: {{value}}',
    currentValueLabel: 'Objetivo aplicado actual',
    appliedPeriod: 'Este objetivo aplica a {{from}} - {{to}}.',
    sourcePeriods: 'Períodos fuente aplicados',
    deleteMetric: 'Eliminar objetivo de {{metric}}',
    deleteShort: 'Borrar',
    deleteApplied: 'Borrar este objetivo',
    overlapHint:
      'Hay objetivos solapados. Borrá los períodos fuente antes de guardar uno nuevo para este rango.',
    status: {
      exact: 'Objetivo exacto configurado',
      overlap: 'Objetivo solapado aplicado',
      empty: 'Sin objetivo para este período',
    },
    periodMode: {
      label: 'Período del objetivo',
      total: 'Total del rango seleccionado',
      month: 'Mensual',
      quarter: 'Trimestral',
    },
    fields: {
      clicks: 'Clics orgánicos',
      impressions: 'Impresiones orgánicas',
    },
    errors: {
      load: 'No se pudieron cargar los objetivos. Intentá de nuevo.',
      invalidValue: 'Los objetivos deben ser enteros positivos.',
      emptySave: 'Ingresá al menos un objetivo antes de guardar.',
      overlap: 'Primero borrá los objetivos solapados para esta métrica.',
      delete: 'No se pudo eliminar el objetivo. Intentá de nuevo.',
    },
  },
  coverage: {
    trigger: 'Ver qué bloques se ven afectados por cada filtro',
    heading: '¿Qué filtros aplican a cada bloque?',
    description:
      'No todos los bloques consumen los mismos datos. Esta tabla muestra qué filtros realmente afectan a cada card de la vista actual.',
    legend: {
      full: 'Aplica',
      partial: 'Aplica parcial',
      none: 'No aplica',
      na: 'N/A en este bloque',
    },
    columns: {
      block: 'Bloque',
      date: 'Fecha',
      scope: 'Alcance',
      brand: 'Marca',
      country: 'País',
      device: 'Dispositivo',
      text: 'Query / URL',
      drilldownUrl: '↓ URL',
      drilldownQuery: '↓ Query',
      note: 'Motivo',
    },
    blocks: {
      heroKpis: 'Hero KPIs (clicks, impr, CTR, posición)',
      brandedSplit: 'Branded vs Non-Branded',
      trafficTrend: 'Evolución de tráfico',
      topCountries: 'Top Países',
      topPages: 'Top Páginas',
      topKeywords: 'Top Keywords',
      conversions: 'Conversiones (GA4)',
      domainAuthority: 'Domain Authority',
      pagesToOptimize: 'Pages to Optimize',
      aiSearch: 'AI Search (GA4)',
      seoKpis: 'SEO KPIs',
      outcomes: 'Outcomes',
      topKeywordsCompact: 'Top Keywords (resumen)',
      intention: 'Intención de búsqueda',
      aiKpis: 'AI KPIs',
      aiSessionsTrend: 'Sesiones AI por día',
      aiTopPages: 'Top páginas AI',
    },
    notes: {
      scopePartial:
        'Con Alcance ≠ "Todas las páginas" recomputa hero y branded; evolución/top países quedan site-wide (snapshot).',
      brandedDefinesSplit: 'Marca define el split del card, no lo filtra.',
      snapshotSiteWide:
        'En la ruta snapshot, evolución y top países quedan site-wide; en la ruta live (país/dispositivo/texto activos) sí se filtran.',
      countryCollapses: 'Filtrar por país colapsa Top Países a esa fila.',
      topPagesHiddenOnUrlDrilldown: 'Tabla oculta cuando hay drill-down de URL.',
      topKeywordsHiddenOnQueryDrilldown: 'Tabla oculta cuando hay drill-down de query.',
      ga4Source: 'Datos vienen de GA4, no soporta los filtros GSC.',
      ga4ScopeOnly: 'GA4 solo respeta el rango de fechas y el scope GA4 propio.',
      weeklySnapshot: 'Snapshot semanal de DataForSEO, no filtra por período.',
      pagesToOptimizeBlogPath: 'Solo respeta blogPathPrefix configurado en la integración.',
      aiTopPagesDrilldownWritesUrl:
        'El click escribe ?pageUrl= en la URL pero la sección AI no filtra. Útil si después abrís Detalle SEO con la URL exacta.',
    },
  },
  urlDrilldown: {
    back: 'Volver a la lista',
    label: 'Filtrando por:',
    clear: 'Quitar filtro de URL',
    siteWideTooltip: 'Métrica site-wide, no afectada por filtros',
    aiTrafficBadge: 'Filtrado por URL',
  },
  queryDrilldown: {
    label: 'Filtrando por query:',
    back: 'Volver a la lista',
    clear: 'Quitar filtro de query',
  },
  hero: {
    organicClicks: 'Clics orgánicos',
    impressions: 'Impresiones',
    ctr: 'CTR',
    avgPosition: 'Posición promedio',
    aiUsers: 'Usuarios desde IA',
    goalProgress: '{{percent}}% de {{goal}}',
    momDelta: '{{percent}} vs período previo',
    momDeltaAbsolute: '{{value}} vs período previo',
    noComparison: 'Sin comparación',
    noGoal: 'Sin objetivo configurado',
  },
  seo: {
    sectionTitle: 'SEO · Search Console',
    trafficTrend: {
      title: 'Evolución de tráfico',
      subtitle: 'Clics e impresiones del período seleccionado. Excluye el período en curso.',
      clicks: 'Clics',
      impressions: 'Impresiones',
      preliminary: 'Preliminar',
      preliminaryBucket: 'Incluye días preliminares',
      dataThrough: 'Datos hasta el {{date}}.',
      preliminaryNote:
        'Los tramos punteados son preliminares: Search Console todavía los está procesando y pueden cambiar.',
      noDataYet:
        'Todavía no hay datos de este período: Search Console publica cada día al día siguiente.',
    },
    brandedSplit: {
      title: 'Branded vs Non-branded',
      subtitle: 'Participación del tráfico no branded sobre el total orgánico.',
      branded: 'Branded',
      nonBranded: 'Non-branded',
      nonBrandedShare: 'Share non-branded',
      goal: 'Meta non-branded: {{value}}',
    },
    topPages: {
      title: 'Rendimiento de páginas',
      subtitle: 'Páginas que mejor performan en el período.',
      subtitlePlatformBlogs:
        'Notas de Entregables y publicaciones de Referent con datos, con su rendimiento.',
      platformBlogSummary: {
        title: 'Notas de Entregables',
        total: '{{value}} notas cargadas en Entregables',
        empty: 'No hay notas cargadas en Entregables.',
        withData: 'Con datos',
        withoutImpressions: 'Sin impresiones',
        withoutUrl: 'Sin URL',
        outsideProperty: 'Fuera de la propiedad',
        publicationsNotInDeliverables:
          '{{value}} publicadas desde Referent que no están en Entregables',
        hint: 'Para corregir una nota, editala en Entregables.',
        error: 'No pudimos cargar el resumen de notas.',
      },
      blogBadge: 'Blog',
      searchPlaceholder: 'Buscar por URL…',
      pageSizeLabel: 'Filas por página',
      empty: 'Ninguna página coincide con los filtros activos.',
      syncing: 'Generando el snapshot completo — refrescá en un momento.',
      columns: {
        url: 'URL',
        clicks: 'Clics',
        impressions: 'Impresiones',
        ctr: 'CTR',
        avgPosition: 'Pos. prom.',
      },
    },
    topKeywords: {
      title: 'Top keywords',
      subtitle: 'Queries que más impacto generan.',
      brandedBadge: 'Marca',
      nonBrandedBadge: 'No marca',
      searchPlaceholder: 'Buscar por query…',
      pageSizeLabel: 'Filas por página',
      empty: 'Ninguna keyword coincide con los filtros activos.',
      syncing: 'Generando el snapshot completo — refrescá en un momento.',
      brandFilter: {
        all: 'Todas',
        branded: 'Solo marca',
        nonBranded: 'Solo no-marca',
      },
      columns: {
        query: 'Query',
        clicks: 'Clics',
        impressions: 'Impresiones',
        ctr: 'CTR',
        avgPosition: 'Pos. prom.',
      },
    },
    pagination: {
      summary: 'Mostrando {{from}}-{{to}} de {{total}}',
      prev: 'Anterior',
      next: 'Siguiente',
    },
  },
  effortVsGrowth: {
    title: 'Esfuerzo vs crecimiento',
    betaBadge: 'Beta',
    subtitle:
      'Contenidos publicados por mes desde la plataforma vs los clicks orgánicos del sitio.',
    summaryBlogs: '{{count}} blogs publicados',
    summaryEmpty: 'No hay blogs publicados desde la plataforma en este período.',
    chartClicksLabel: 'Clicks orgánicos',
    chartBlogsLabel: 'Blogs publicados',
    tooltipBlogsTitle: 'Blogs publicados este mes',
    feedbackPrompt: '¿Te resulta útil este gráfico?',
    feedbackThanks: 'Gracias por el feedback.',
    feedbackYes: 'Sí',
    feedbackNo: 'No',
  },
  conversions: {
    title: 'Registros',
    subtitle: 'Conversiones desde orgánico y plataformas de IA. Excluye tráfico directo.',
    notConfigured: 'GA4 no conectado',
    notConfiguredHint: 'Conectá GA4 para empezar a trackear conversiones.',
    loading: 'Calculando conversiones…',
    loadingHint: 'Consultando GA4 sobre orgánico + IA.',
    deltaUp: '+{{value}} vs anterior',
    deltaDown: '{{value}} vs anterior',
    deltaFlat: 'Sin cambios',
    breakdown: {
      organic: 'Orgánico',
      ai: 'Desde IA',
    },
  },
  domainAuthority: {
    title: 'Autoridad de dominio',
    score: 'Authority score',
    referringDomains: 'Dominios referentes',
    backlinks: 'Backlinks',
    deltaUp: '+{{value}} vs anterior',
    deltaDown: '{{value}} vs anterior',
    deltaFlat: 'Sin cambios',
    noDelta: 'Primer snapshot',
    notAvailable: 'Datos no disponibles aún',
    notAvailableHint: 'Lo actualizamos semanalmente. Volvé en unas horas.',
    tooltip:
      'Authority score (0-100) estima la fuerza del dominio según su perfil de backlinks. Se actualiza semanalmente vía DataForSEO.',
  },
  blogDetail: {
    selectorLabel: 'Analizar un blog puntual',
    selectorPlaceholder: 'Elegí un blog publicado…',
    searchPlaceholder: 'Buscar por título o URL…',
    empty: 'No hay blogs publicados.',
    clear: 'Limpiar selección',
    daysSincePublished: 'hace {{days}} días',
    topQueriesTitle: 'Top queries para esta página',
    noQueries: 'No hay queries de GSC para esta página en el período seleccionado.',
    error: 'No se pudo cargar el detalle del blog.',
    scopeLockedBadge: '1 blog seleccionado',
  },
  ai: {
    sectionTitle: 'Tráfico desde IA',
    mentionShare: {
      title: 'Menciones en LLMs',
      subtitle: 'Cómo los LLMs citan a {{brand}} vs el set competitivo.',
      aiUsers: 'usuarios desde IA',
      topReferrer: 'Top referrer: {{platform}}',
    },
    authority: {
      title: 'Autoridad externa',
      subtitle: 'Perfiles en fuentes que alimentan el reconocimiento de entidad de los LLMs.',
      completeRatio: '{{complete}} de {{total}} completos',
      status: {
        complete: 'Completo',
        incomplete: 'Incompleto',
        missing: 'Faltante',
      },
    },
  },
  content: {
    sectionTitle: 'Entregables del mes',
    subtitle: 'Output producido contra la meta mensual.',
    metricProgress: '{{percent}}% de la meta',
    metrics: {
      backlinks: 'Backlinks',
      notasGeneradas: 'Notas generadas',
      notasPublicadas: 'Notas publicadas',
      landingsGeneradas: 'Landings generadas',
      landingsPublicadas: 'Landings publicadas',
      optimizaciones: 'Optimizaciones',
    },
  },
  pagesToOptimize: {
    sectionTitle: 'Páginas a optimizar',
    title: 'Oportunidades detectadas',
    subtitle:
      'Top 10 con CTR bajo o página 2 con CTR alto — candidatas con mayor uplift potencial.',
    loading: 'Buscando candidatos en Search Console…',
    error: 'No pudimos cargar los candidatos. Reintentá más tarde.',
    empty:
      'No detectamos páginas candidatas en este rango. Probá ampliar el rango de fechas.',
    columns: {
      url: 'URL',
      clicks: 'Clics',
      impressions: 'Impresiones',
      ctr: 'CTR',
      position: 'Posición',
      tier: 'Tier',
    },
    tiers: {
      tier1_top10_low_ctr: 'Top 10 · CTR bajo',
      tier2_page2_high_ctr: 'Página 2 · CTR alto',
    },
  },
  bulkOptimization: {
    submit: 'Optimizar seleccionadas ({{count}})',
    selectionCount: '{{count}} de {{max}} seleccionadas',
    selectRow: 'Seleccionar {{path}}',
    selectAll: 'Seleccionar todas',
    retry: 'Reintentar',
    useSkill: 'Usar skill',
    copied: 'Comando de la skill copiado al portapapeles',
    copyFailed: 'No se pudo copiar el comando',
    columns: {
      status: 'Estado',
    },
    status: {
      queued: 'En cola',
      running: 'Procesando',
      pending_cms_push: 'Publicando',
      applied: 'Aplicado',
      needs_review: 'Revisar',
      rolled_back: 'Revertido',
      failed: 'Falló',
    },
    cms: {
      webflow: 'Webflow',
      wordpress: 'WordPress',
    },
    disabled: {
      no_cms: 'Primero conectá una integración de Webflow o WordPress.',
      framer_only:
        'Las actualizaciones in-place de Framer todavía no están soportadas — usá el editor de Framer.',
      wordpress_com: 'WordPress.com todavía no está soportado — usá WordPress self-hosted.',
      expired: 'Reconectá tu CMS para seguir optimizando.',
      job_in_flight: 'Ya hay un lote corriendo — esperá a que termine.',
      empty_selection: 'Seleccioná al menos una página para optimizar.',
    },
    toast: {
      submitted: 'Optimizando {{count}} páginas — podés salir de esta pantalla.',
      applied: 'Optimizada {{path}}',
      needsReview: '{{path}} necesita revisión',
      failed: 'No se pudo optimizar {{path}}',
    },
    submitError: {
      JOB_ALREADY_IN_FLIGHT: 'Ya hay un lote corriendo para tu organización.',
      RUN_ALREADY_IN_FLIGHT: 'Algunas URLs seleccionadas ya se están optimizando.',
      INTEGRATION_NOT_CONNECTED: 'Primero conectá una integración de Webflow o WordPress.',
      INTEGRATION_PROVIDER_NOT_SUPPORTED:
        'Este CMS todavía no está soportado para optimización en lote.',
      INTEGRATION_NOT_HEALTHY: 'Reconectá tu CMS para seguir optimizando.',
      ROW_LIMIT_EXCEEDED: 'Podés optimizar como máximo 10 páginas a la vez.',
      EMPTY_SELECTION: 'Seleccioná al menos una página para optimizar.',
      DUPLICATE_URLS_IN_REQUEST: 'Tu selección tiene URLs duplicadas.',
      QUEUE_UNAVAILABLE: 'La cola no está disponible por el momento — probá de nuevo en un rato.',
      RETRY_LIMIT_EXCEEDED: 'Esta página llegó al límite de reintentos.',
    },
    modal: {
      title: '¿Optimizar {{count}} páginas?',
      description:
        'Cada página corre el pipeline de optimización completo y se publica en tu CMS automáticamente.',
      targetCms: 'CMS destino',
      site: 'Sitio',
      estimatedCost: 'Costo estimado',
      estimateNote: 'Solo un estimado — el costo real se reporta después de procesar cada página.',
      confirm: 'Optimizar {{count}}',
    },
    drawer: {
      title: 'Antes / después',
      keyword: 'Keyword objetivo',
      needsReviewReason: 'Requiere revisión manual ({{reason}}) — no se publicó en el CMS.',
      h1: 'H1',
      titleTag: 'Title tag',
      metaDescription: 'Meta description',
      wordCount: 'Cantidad de palabras',
      kwMentions: 'Menciones de keyword',
      noDiff: 'No se registraron cambios de campos para esta corrida.',
      cost: 'Costo IA: ${{cost}}',
    },
    banner: {
      summary: '{{applied}} aplicadas · {{failed}} fallidas · {{needsReview}} a revisar',
      cost: 'costo ${{cost}}',
      dismiss: 'Descartar',
    },
  },
  aiTrafficPage: {
    title: 'Tráfico desde IA',
    subtitle:
      'Métricas de GA4 para visitantes desde plataformas de IA — quién llega, cómo interactúan y dónde se construye autoridad.',
    loading: {
      title: 'Conectando con GA4',
      subtitle: 'Sincronizando sesiones y eventos desde plataformas de IA…',
    },
  },
  aiTraffic: {
    title: 'Google Analytics 4',
    subtitle: 'Tráfico de tu sitio segmentado por tipo de fuente.',
    scopeToggle: {
      label: 'Filtrar por tipo de tráfico',
      ai: 'Sólo IA',
      all: 'Todo el tráfico',
    },
    cards: {
      totalUsers: 'Usuarios',
      sessions: 'Sesiones',
      engagementRate: 'Engagement Rate',
      bounceRate: 'Bounce Rate',
      eventCount: 'Eventos',
    },
    sessionsChart: {
      title: 'Sesiones a lo largo del tiempo',
      current: 'Período actual',
      previous: 'Período anterior',
    },
    notConnected: {
      title: 'Google Analytics 4 no está conectado',
      description: 'Conectá GA4 para ver tráfico segmentado por fuente.',
      cta: 'Conectar GA4',
    },
    kpis: {
      aiUsers: 'Usuarios desde IA',
      aiSessions: 'Sesiones desde IA',
      engagementRate: 'Tasa de interacción',
      bounceRate: 'Tasa de rebote',
      avgEngagement: 'Tiempo prom. de interacción',
      keyEvents: 'Eventos clave',
    },
    sessionsTrend: {
      title: 'Sesiones desde IA en el tiempo',
      subtitle: 'Sólido: período actual · punteado: período anterior.',
      current: 'Actual',
      previous: 'Anterior',
      empty: 'Sin datos diarios para este período. Probá refrescar o ampliar el rango.',
    },
    refresh: 'Refrescar',
    refreshing: 'Refrescando…',
    topPages: {
      title: 'Top páginas por tráfico desde IA',
      subtitle: 'Dónde aterrizan los visitantes desde LLMs y cómo interactúan.',
      columns: {
        page: 'Página',
        sessions: 'Sesiones',
        totalUsers: 'Usuarios',
        engagement: 'Interacción',
        views: 'Vistas',
        keyEvents: 'Eventos clave',
      },
    },
    platformEngagement: {
      title: 'Engagement por plataforma IA',
      subtitle: 'Sesiones, tiempo prom. y rebote por LLM referrer.',
      avgTime: 'Tiempo prom.: {{value}}',
      bounceRate: 'Rebote: {{value}}',
    },
  },
  deliverablesPage: {
    title: 'Entregables del mes',
    subtitle: 'Output producido en este período vs la meta mensual.',
  },
  deliverables: {
    pageKicker: 'Scorecard',
    kicker: 'Abril 2026',
    ringLabel: 'Cumplimiento general',
    featured: 'Destacado',
    progressOf: '{{percent}}% de la meta',
    headline: {
      onPace:
        '{{delivered}} de {{total}} entregables completados — vamos en ritmo para cerrar fuerte.',
      steady:
        '{{delivered}} de {{total}} entregables hechos — progreso sostenido con margen para acelerar.',
      behind:
        '{{delivered}} de {{total}} entregables hechos — estamos atrás del plan, priorizar las próximas semanas.',
    },
    subhead:
      '{{onTrack}} de {{total}} streams en ritmo este mes, {{behind}} necesitan atención. Foco en los pipelines de publicación para convertir drafts en salidas en vivo.',
    stats: {
      delivered: 'Entregados',
      onTrack: 'En ritmo',
      behind: 'Atrasados',
    },
    status: {
      complete: 'Completo',
      over: 'Sobre-entregado',
      on: 'En ritmo',
      atRisk: 'En riesgo',
      behind: 'Atrasado',
    },
    breakdown: {
      kicker: 'Por stream',
      title: 'Breakdown por entregable',
    },
    velocity: {
      kicker: 'Ritmo',
      title: 'Velocidad semanal',
      subtitle: 'Entregables acumulados este mes contra el ritmo objetivo mensual.',
      ofTargetPace: 'del ritmo objetivo',
      pace: 'Ritmo objetivo',
      actual: 'Entregado',
      monthTarget: 'Meta del mes',
    },
    alert: {
      label: 'Necesita atención',
      copy: 'Solo {{actual}} de {{goal}} publicadas. Los drafts están listos — desbloquear publicación para recuperar el mes.',
      cta: 'Ver cola',
    },
  },
  gsc: {
    emptyState: {
      eyebrow: 'Search Console',
      title: 'Conectá Google Search Console para ver tu performance',
      description:
        'Traemos tus clics, impresiones, CTR, posición, top páginas y queries desde GSC. Sin conectar, este tablero queda vacío.',
      features: {
        realTraffic: 'Datos reales de clics e impresiones',
        trendAnalysis: 'Evolución mensual de 13 meses',
        topContent: 'Top páginas y queries — branded vs non-branded',
      },
      cta: 'Conectar Google Search Console',
    },
    syncing: {
      title: 'Estamos sincronizando tus datos de Search Console',
      description:
        'Acabás de conectar GSC. La primera carga puede tardar unos minutos — refrescá en breve para ver métricas reales.',
    },
    error: {
      title: 'No pudimos traer los datos de Search Console',
      description: 'Probá refrescar la página. Si el error persiste, revisá la integración.',
      cta: 'Revisar integración',
    },
    blogPrefix: {
      label: 'Prefijo del blog',
      description: 'Se usa para filtrar métricas "Solo blog". Ejemplo: /blog o /recursos.',
      placeholder: '/blog',
      save: 'Guardar',
      saved: 'Guardado',
      invalid: 'Debe empezar con "/" y contener solo letras, números, guiones o barras',
    },
    lastSyncedAt: 'Último sync: {{relative}}',
    preview: {
      organicClicks: 'Clics orgánicos',
      impressions: 'Impresiones',
      ctr: 'CTR',
      badge: 'Vista previa',
    },
  },
  seoSummary: {
    title: 'Resumen ejecutivo · {{name}}',
    subtitle:
      'Consolidado de SEO y tráfico desde IA — pensado para una mirada rápida del estado del dominio.',
    blocks: {
      aiSearch: {
        title: 'AI Search',
        subtitle: 'Visibilidad y tráfico desde plataformas de IA (GA4).',
        platforms: {
          title: 'Distribución por LLM',
          totalSessions: '{{value}} sesiones',
          empty: 'Aún no hay sesiones desde plataformas de IA en este rango.',
        },
      },
      seo: {
        title: 'SEO',
        subtitle: 'Performance orgánica desde Google Search Console.',
      },
      outcomes: {
        title: 'Resultados',
        subtitle: 'Autoridad del dominio y conversiones del período.',
      },
    },
    countries: {
      title: 'Distribución por países',
      subtitle: 'De dónde viene tu tráfico orgánico.',
      empty: 'Aún no hay datos por país en este rango.',
    },
    intention: {
      title: 'Intención de búsqueda',
      subtitle: 'Cómo se reparten tus queries entre los distintos tipos de intent.',
      empty: 'Aún no tenemos queries suficientes para clasificar.',
      heuristicNote:
        'Clasificación heurística sobre tus top queries — sirve para una visión general.',
      types: {
        informational: 'Informacional',
        commercial: 'Comercial',
        transactional: 'Transaccional',
        navigational: 'Navegacional',
      },
    },
    viewDetails: 'Ver detalle SEO',
    viewAiTraffic: 'Ver tráfico desde IA',
  },
  ghost: {
    sectionTitle: 'Próximamente',
    comingSoon: 'Próximamente',
    organicVsPaid: {
      title: 'Orgánico vs Paid',
      description: 'Split de fuentes — conectá GA4 para desbloquear.',
    },
    aiReadiness: {
      title: 'Preparación para IA',
      description: 'llms.txt, cobertura de schema, citabilidad.',
    },
    contentReuse: {
      title: 'Reutilización de contenido',
      description: 'Notas orgánicas top sin reutilizar en otros canales.',
    },
    omnichannel: {
      title: 'Calendario omnicanal',
      description: 'Próximos posts en blog, LinkedIn, YouTube.',
    },
  },
} as const
